<div class="receipt-product-wrapper" *ngFor="let product of products">
  <div class="receipt-product-info">
    <span>{{ product.name }} x {{ product.quantity }}</span>
    <span>{{ product.price | currency }}</span>
  </div>
</div>
